import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import ClassroomTreeView from 'components/common/ClassroomTreeView';
import Select from 'components/common/Select';
import useClassrooms from 'state/hooks/use-classrooms';
import useReports from 'state/hooks/use-reports';

const ClassroomReportFilter: React.FC = () => {
  const [{ filters }, { setQuery }] = useReports();
  const [{ activeClassroom }] = useClassrooms();
  const [selected, setSelected] = useState<number[]>([]);

  const areAllStudentsSelected = (studentIds: number[]) =>
    activeClassroom.students?.every((student) => studentIds.includes(student.id));

  useEffect(() => {
    setSelected(filters.studentIds ?? []);
  }, [filters.studentIds]);

  const applyFilter = () => {
    if (selected !== filters.studentIds) {
      const studentIds =
        selected.length && !areAllStudentsSelected(selected) ? selected : undefined;
      setQuery({ studentIds }, 'pushIn');
    }
  };

  return (
    <Box width={276}>
      <Select
        multiple
        value={selected}
        renderValue={() => activeClassroom.name}
        onClose={applyFilter}
      >
        <ClassroomTreeView classroom={activeClassroom} values={selected} onChange={setSelected} />
      </Select>
    </Box>
  );
};

export default ClassroomReportFilter;
